import React, { useState } from 'react';
import { GlobeIcon, Loader2Icon, SparklesIcon, ArrowRightLeftIcon } from 'lucide-react';
export function MultiLanguageOutput() {
  const [isGenerating, setIsGenerating] = useState(false);
  const [hasGenerated, setHasGenerated] = useState(false);
  const [targetLang, setTargetLang] = useState('es-mx');
  const handleGenerate = () => {
    setIsGenerating(true);
    setTimeout(() => {
      setIsGenerating(false);
      setHasGenerated(true);
    }, 2000);
  };
  return <div className="max-w-5xl mx-auto space-y-8 animate-in fade-in duration-500" data-id="element-467">
      <div data-id="element-468">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-469">
          Adaptación Multi-Idioma
        </h1>
        <p className="text-slate-500 mt-1" data-id="element-470">
          No solo traduce, adapta culturalmente tu copy para diferentes mercados
          hispanos y US Hispanic.
        </p>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200" data-id="element-471">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-472">
          <div className="space-y-2" data-id="element-473">
            <label className="block text-sm font-medium text-slate-700" data-id="element-474">
              Texto Original (Español Neutro)
            </label>
            <textarea className="w-full h-32 p-4 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none" defaultValue="Descubre cómo preparar pasteles deliciosos y rentables. Con esta guía aprenderás a costear tus ingredientes y empacar tus pedidos para ganar más dinero." data-id="element-475" />
          </div>
          <div className="space-y-4" data-id="element-476">
            <div className="space-y-2" data-id="element-477">
              <label className="block text-sm font-medium text-slate-700" data-id="element-478">
                Mercado Destino
              </label>
              <select value={targetLang} onChange={e => setTargetLang(e.target.value)} className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white" data-id="element-479">
                <option value="es-mx" data-id="element-480">🇲🇽 Español (México)</option>
                <option value="es-ar" data-id="element-481">🇦🇷 Español (Argentina)</option>
                <option value="es-es" data-id="element-482">🇪🇸 Español (España)</option>
                <option value="en-us" data-id="element-483">🇺🇸 Inglés (US Hispanic)</option>
                <option value="pt-br" data-id="element-484">🇧🇷 Portugués (Brasil)</option>
              </select>
            </div>
            <div className="bg-indigo-50 p-4 rounded-lg border border-indigo-100" data-id="element-485">
              <p className="text-sm text-indigo-800 flex items-start gap-2" data-id="element-486">
                <GlobeIcon className="w-5 h-5 shrink-0 mt-0.5" data-id="element-487" />
                La IA adaptará modismos. Por ejemplo, "pastel" cambiará a
                "torta" en Argentina, o "cake" en US Hispanic.
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-end pt-6 border-t border-slate-100" data-id="element-488">
          <button onClick={handleGenerate} disabled={isGenerating} className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-2.5 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 transition-colors" data-id="element-489">
            {isGenerating ? <>
                <Loader2Icon className="w-5 h-5 animate-spin" data-id="element-490" /> Adaptando...
              </> : <>
                <SparklesIcon className="w-5 h-5" data-id="element-491" /> Adaptar Texto
              </>}
          </button>
        </div>
      </div>

      {hasGenerated && <div className="grid grid-cols-1 md:grid-cols-2 gap-6 animate-in slide-in-from-bottom-4 duration-500" data-id="element-492">
          <div className="bg-slate-50 p-6 rounded-xl border border-slate-200" data-id="element-493">
            <span className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-2 block" data-id="element-494">
              Original
            </span>
            <p className="text-slate-700" data-id="element-495">
              Descubre cómo preparar pasteles deliciosos y rentables. Con esta
              guía aprenderás a costear tus ingredientes y empacar tus pedidos
              para ganar más dinero.
            </p>
          </div>

          <div className="hidden md:flex items-center justify-center absolute left-1/2 -translate-x-1/2 mt-12" data-id="element-496">
            <div className="bg-white p-2 rounded-full shadow-sm border border-slate-200 z-10" data-id="element-497">
              <ArrowRightLeftIcon className="w-5 h-5 text-slate-400" data-id="element-498" />
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm border-2 border-indigo-500 relative" data-id="element-499">
            <span className="text-xs font-bold text-indigo-600 uppercase tracking-wider mb-2 block" data-id="element-500">
              Adaptado (
              {targetLang === 'es-mx' ? 'México' : targetLang === 'es-ar' ? 'Argentina' : targetLang === 'en-us' ? 'US Hispanic' : 'Destino'}
              )
            </span>
            {targetLang === 'es-mx' && <p className="text-slate-900 font-medium" data-id="element-501">
                Descubre cómo preparar pasteles riquísimos y rentables. Con esta
                guía aprenderás a sacar los costos de tus insumos y armar tus
                empaques para tener más lana.
              </p>}
            {targetLang === 'es-ar' && <p className="text-slate-900 font-medium" data-id="element-502">
                Descubrí cómo preparar tortas riquísimas y rentables. Con esta
                guía vas a aprender a costear tus ingredientes y armar tus
                pedidos para ganar más plata.
              </p>}
            {targetLang === 'en-us' && <p className="text-slate-900 font-medium" data-id="element-503">
                Discover how to bake delicious and profitable cakes. With this
                guide, you'll learn how to price your ingredients and package
                your orders to make more money.
              </p>}
            {(targetLang === 'es-es' || targetLang === 'pt-br') && <p className="text-slate-900 font-medium" data-id="element-504">
                Texto adaptado culturalmente para el mercado seleccionado,
                ajustando modismos y expresiones locales.
              </p>}
          </div>
        </div>}
    </div>;
}